function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "id2"
}, /*#__PURE__*/React.createElement("path", {
  d: "m446 219.95h48v105.05h-48z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "id3"
}, /*#__PURE__*/React.createElement("path", {
  d: "m397 510h128v33.605h-128z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#15122a",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 6.7218
}, /*#__PURE__*/React.createElement("path", {
  d: "m309.84 290.32c0 1.7422-1.4297 3.1719-3.1758 3.1719h-229.5c-1.7461 0-3.1719-1.4297-3.1719-3.1719v-229.18c0-1.7461 1.4258-3.1758 3.1719-3.1758h229.5c1.7461 0 3.1758 1.4297 3.1758 3.1758z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m114.47 127.57h154.89"
}), /*#__PURE__*/React.createElement("path", {
  d: "m114.47 159.67h154.89"
}), /*#__PURE__*/React.createElement("path", {
  d: "m114.47 191.77h154.89"
}), /*#__PURE__*/React.createElement("path", {
  d: "m114.47 223.88h154.89"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-283.39 -219.99)",
  clipPath: "url(#id2)"
}, /*#__PURE__*/React.createElement("path", {
  transform: "matrix(.11211 0 0 -.11195 201.3 619.84)",
  d: "m2213 3078.8v279.9c0 101.05 81.919 182.94 182.93 182.94 101.05 0 182.93-81.89 182.93-182.94v-511.72c0-101.05-81.884-182.94-182.93-182.94-100.18 0-181.54 80.53-182.9 180.39",
  fill: "none",
  stroke: "#15122a",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 60
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m73.992 61.136c0-1.7461 1.4258-3.1758 3.1719-3.1758h53.047c1.7461 0 3.2266-0.17187 3.2852-0.38281 0.0586-0.21484-1.2852-0.71094-2.9883-1.1055l-72.887-16.973c-1.6992-0.41406-3.4023 0.64063-3.7812 2.3438l-50.504 223.57c-0.38281 1.6992 0.6914 3.4531 2.3789 3.8945l65.066 15.652c1.6992 0.41015 3.1016-0.67579 3.1133-2.4258l0.0703-7.6172c0.0117-1.7461 0.0274-4.6016 0.0274-6.3477v-207.43",
  fill: "#00a499"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m73.993 61.136c0-1.7461 1.4258-3.1758 3.1719-3.1758h53.047c1.7461 0 3.2266-0.17188 3.2852-0.38282 0.0586-0.21484-1.2852-0.71094-2.9883-1.1055l-72.887-16.973c-1.6992-0.41406-3.4024 0.64062-3.7813 2.3437l-50.504 223.57c-0.38281 1.6992 0.69141 3.4531 2.3789 3.8945l65.067 15.652c1.6992 0.41016 3.1016-0.67578 3.1133-2.4258l0.07031-7.6172c0.01171-1.7461 0.02734-4.6016 0.02734-6.3477zm0 0",
  fill: "none",
  stroke: "#15122a",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 6.7218
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m229.61 319.62c1.7031 0.38672 3.4102-0.6875 3.7969-2.3906l4.457-19.73c0.37891-1.6992-0.73047-3.1016-2.4805-3.1133l-116.23-0.53516c-1.7461-8e-3 -1.7812 0.30469-0.0781 0.69141l110.54 25.078",
  fill: "#00a499"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-283.39 -219.99)",
  clipPath: "url(#id3)"
}, /*#__PURE__*/React.createElement("path", {
  transform: "matrix(.11211 0 0 -.11195 201.3 619.84)",
  d: "m2780.5 716.68c15.192-3.4543 30.419 6.1409 33.869 21.319l39.757 176.27c3.3799 15.178-6.5159 27.704-22.126 27.809l-1036.8 4.7801c-15.575 0.0698-15.889-2.7215-0.6968-6.1758zm0 0",
  fill: "none",
  stroke: "#15122a",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 60
}));

function SvgIntroFormIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 417.43,
    height: 430.42,
    viewBox: "0 0 313.23 323.06",
    zoomAndPan: "magnify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroFormIcon2);
export default __webpack_public_path__ + "static/media/introFormIcon2.05682807.svg";
export { ForwardRef as ReactComponent };